<template>
  <div class="w-full">
    <vs-popup
      :active.sync="localActive"
      class="modal-apple-nps"
      title=" "
      button-close-hidden
    >
      <div id="disparo-massa-nps-container" class="vs-con-loading__container apple-modal-wrapper" @click.stop>
        <!-- Apple Style Close Button -->
        <button type="button" class="apple-close-btn" @click="closeModal" title="Fechar">
          <vs-icon icon="close" size="16px"></vs-icon>
        </button>

        <!-- Header Apple Style -->
        <div class="apple-modal-header mb-4">
          <div class="flex items-center gap-3">
            <div class="apple-header-icon-box">
              <vs-icon icon="send" size="22px" color="#0071e3"></vs-icon>
            </div>
            <div>
              <h3 class="apple-modal-title">Disparo em Massa NPS</h3>
              <p class="apple-modal-subtitle">
                Selecione os clientes e confirme os números de WhatsApp para envio da pesquisa.
              </p>
            </div>
          </div>
        </div>

        <!-- ESTADO DE PROGRESSO / RESULTADO -->
        <div v-if="etapa === 'progresso'" class="py-6 px-2">
          <div class="text-center mb-8">
            <div class="apple-progress-status-icon mb-3">
              <vs-icon
                v-if="progress.status === 'completed'"
                icon="check_circle"
                size="56px"
                color="#34c759"
              ></vs-icon>
              <vs-icon
                v-else-if="progress.status === 'error'"
                icon="error"
                size="56px"
                color="#ff3b30"
              ></vs-icon>
              <div v-else class="apple-spinner-ring"></div>
            </div>

            <h4 class="apple-progress-heading" :style="{ color: corStatus }">
              {{ progress.message }}
            </h4>
          </div>

          <!-- Barra de Progresso Apple Style -->
          <div class="apple-progress-track mb-8">
            <div class="flex justify-between items-center mb-2">
              <span class="text-xs font-semibold text-slate-500 uppercase tracking-wider">Status do Envio</span>
              <span class="text-sm font-bold" :style="{ color: corStatus }">{{ progress.percent }}%</span>
            </div>
            <div class="apple-progress-bar-bg">
              <div
                class="apple-progress-bar-fill"
                :style="{ width: progress.percent + '%', backgroundColor: corStatus }"
              ></div>
            </div>
          </div>

          <!-- Cards Métricas Apple Style -->
          <div class="apple-metrics-grid mb-8">
            <div class="apple-metric-card">
              <span class="apple-metric-num text-slate-800">{{ progress.total }}</span>
              <span class="apple-metric-label">Total Selecionado</span>
            </div>
            <div class="apple-metric-card apple-metric-card-success">
              <span class="apple-metric-num text-emerald-600">{{ progress.sent }}</span>
              <span class="apple-metric-label">Enviados</span>
            </div>
            <div class="apple-metric-card apple-metric-card-danger">
              <span class="apple-metric-num text-rose-600">{{ progress.failed }}</span>
              <span class="apple-metric-label">Falhas</span>
            </div>
          </div>

          <!-- Botão Fechar -->
          <div class="text-center">
            <button
              v-if="progress.status === 'completed' || progress.status === 'error'"
              type="button"
              class="apple-btn apple-btn-primary"
              @click="finalizarEnvio"
            >
              Concluir e Ver Resultados
            </button>
          </div>
        </div>

        <!-- ETAPA DE SELEÇÃO E CONFIGURAÇÃO -->
        <div v-else>
          <!-- Filtros de Período & Busca -->
          <div class="apple-filter-toolbar mb-3">
            <div class="flex flex-wrap items-center gap-2">
              <!-- Presets de Período -->
              <div class="apple-segmented-group">
                <button
                  type="button"
                  class="apple-seg-btn"
                  :class="{ active: filtroPreset === '7' }"
                  @click="aplicarPresetDias('7')"
                >7 dias</button>
                <button
                  type="button"
                  class="apple-seg-btn"
                  :class="{ active: filtroPreset === '30' }"
                  @click="aplicarPresetDias('30')"
                >30 dias</button>
                <button
                  type="button"
                  class="apple-seg-btn"
                  :class="{ active: filtroPreset === '60' }"
                  @click="aplicarPresetDias('60')"
                >60 dias</button>
                <button
                  type="button"
                  class="apple-seg-btn"
                  :class="{ active: filtroPreset === '90' }"
                  @click="aplicarPresetDias('90')"
                >90 dias</button>
                <button
                  type="button"
                  class="apple-seg-btn"
                  :class="{ active: filtroPreset === 'all' }"
                  @click="aplicarPresetDias('all')"
                >Todos</button>
              </div>

              <!-- Datas Personalizadas -->
              <div class="flex items-center gap-1 text-xs text-slate-500">
                <span>De:</span>
                <input
                  type="date"
                  v-model="filtroDataDe"
                  class="apple-date-input"
                  @change="onDateChange"
                />
                <span>Até:</span>
                <input
                  type="date"
                  v-model="filtroDataAte"
                  class="apple-date-input"
                  @change="onDateChange"
                />
              </div>
            </div>

            <!-- Busca Rápida -->
            <div class="apple-search-box">
              <vs-icon icon="search" size="16px" color="#94a3b8"></vs-icon>
              <input
                type="text"
                v-model="filtroBusca"
                placeholder="Buscar cliente, OS, contrato..."
                class="apple-search-input"
                @input="debounceBusca"
              />
              <span
                v-if="filtroBusca"
                class="apple-clear-search"
                @click="limparBusca"
              >×</span>
            </div>
          </div>

          <!-- Barra de Ações Rápidas de Seleção -->
          <div class="apple-controls-bar mb-3">
            <div class="flex items-center gap-2">
              <button
                type="button"
                class="apple-pill-btn"
                :class="{ active: todosSelecionadosNaPagina }"
                @click="toggleSelecionarPagina"
              >
                {{ todosSelecionadosNaPagina ? 'Desmarcar Página' : 'Selecionar Página' }}
              </button>
              <button
                type="button"
                class="apple-pill-btn"
                @click="toggleSelecionarTodosTotal"
              >
                {{ todosSelecionadosTotal ? 'Desmarcar Todos (' + totalDisponiveis + ')' : 'Selecionar Todos (' + totalDisponiveis + ')' }}
              </button>
              <span class="text-xs text-slate-500 font-medium ml-2">
                <strong>{{ totalSelecionados }}</strong> selecionados para envio
              </span>
            </div>

            <div class="flex items-center gap-2 text-xs text-slate-500">
              <span>Por página:</span>
              <select v-model="itensPorPagina" class="apple-mini-select" @change="mudarItensPorPagina">
                <option :value="20">20</option>
                <option :value="50">50</option>
                <option :value="100">100</option>
                <option value="all">Todos</option>
              </select>
            </div>
          </div>

          <!-- Tabela de Elegíveis (Apple Clean Table) -->
          <div class="apple-table-card mb-4">
            <div class="apple-table-scroll">
              <table class="apple-table">
                <thead>
                  <tr>
                    <th style="width: 44px; text-align: center;">
                      <input
                        type="checkbox"
                        class="apple-checkbox"
                        :checked="todosSelecionadosNaPagina"
                        @change="toggleSelecionarPagina"
                      />
                    </th>
                    <th style="min-width: 250px;">Cliente & Contrato</th>
                    <th style="min-width: 170px;">Serviço & Status</th>
                    <th style="min-width: 320px;">Número WhatsApp de Envio</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="carregandoElegiveis">
                    <td colspan="4" class="apple-empty-td">
                      <div class="flex items-center justify-center gap-2 py-8 text-slate-400 font-medium">
                        <vs-icon icon="hourglass_empty" size="20px"></vs-icon>
                        Carregando contratos elegíveis...
                      </div>
                    </td>
                  </tr>
                  <tr v-else-if="elegiveis.length === 0">
                    <td colspan="4" class="apple-empty-td">
                      <div class="py-8 text-center text-slate-400 font-medium">
                        Nenhum contrato encontrado para os filtros selecionados.
                      </div>
                    </td>
                  </tr>
                  <tr
                    v-for="(item, idx) in elegiveis"
                    :key="'elegivel-' + item.id_os + '-' + idx"
                    class="apple-tr"
                    :class="{ 'is-selected': item.selecionado, 'is-disabled': !item.temTelefoneValido }"
                  >
                    <td style="text-align: center;">
                      <input
                        type="checkbox"
                        class="apple-checkbox"
                        v-model="item.selecionado"
                        :disabled="!item.temTelefoneValido"
                      />
                    </td>
                    <td>
                      <div class="apple-client-name">{{ item.nomeCliente }}</div>
                      <div class="apple-client-meta">
                        <span>OS #{{ item.id_os }}</span>
                        <span class="apple-dot">•</span>
                        <span>Contrato #{{ item.id_contrato || 'N/A' }}</span>
                        <span v-if="item.data_execucao" class="apple-dot">•</span>
                        <span v-if="item.data_execucao">{{ formatarData(item.data_execucao) }}</span>
                      </div>
                    </td>
                    <td>
                      <div class="flex flex-col gap-1 items-start">
                        <span class="apple-badge-service">
                          {{ item.service_number }}º serviço
                        </span>
                        <div class="apple-service-meta">
                          <span class="apple-pill-subtle">{{ item.tipoServico || 'OS' }}</span>
                          <span class="apple-pill-stage">{{ item.estagioContrato || 'Pós-Venda' }}</span>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div v-if="item.contatosDisponiveis && item.contatosDisponiveis.length > 0" class="apple-select-wrapper">
                        <select
                          v-model="item.contatoSelecionado"
                          class="apple-select"
                        >
                          <option
                            v-for="c in item.contatosDisponiveis"
                            :key="'contato-' + c.contato + '-' + (c.nome || '')"
                            :value="c.contato"
                          >
                            {{ formatarTelefone(c.contato) }} • {{ c.nome }}
                          </option>
                        </select>
                        <div class="apple-select-arrow">
                          <vs-icon icon="expand_more" size="18px"></vs-icon>
                        </div>
                      </div>
                      <div v-else-if="item.temTelefoneValido">
                        <input
                          type="text"
                          v-model="item.contatoSelecionado"
                          placeholder="Telefone..."
                          class="apple-input-tel"
                        />
                      </div>
                      <div v-else class="apple-tag-danger">
                        <vs-icon icon="error_outline" size="14px"></vs-icon>
                        <span>Sem WhatsApp cadastrado</span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- Rodapé com Paginação e Ações Apple -->
          <div class="apple-modal-footer">
            <!-- Paginação Info & Controles -->
            <div class="flex items-center gap-3">
              <span class="apple-footer-summary">
                Mostrando <strong>{{ elegiveis.length }}</strong> de <strong>{{ totalDisponiveis }}</strong> elegíveis
              </span>
              <div v-if="totalPaginas > 1" class="apple-pagination-controls">
                <button
                  type="button"
                  class="apple-page-btn"
                  :disabled="paginaAtual <= 1"
                  @click="mudarPagina(paginaAtual - 1)"
                >
                  <vs-icon icon="chevron_left" size="16px"></vs-icon>
                </button>
                <span class="apple-page-indicator">
                  {{ paginaAtual }} / {{ totalPaginas }}
                </span>
                <button
                  type="button"
                  class="apple-page-btn"
                  :disabled="paginaAtual >= totalPaginas"
                  @click="mudarPagina(paginaAtual + 1)"
                >
                  <vs-icon icon="chevron_right" size="16px"></vs-icon>
                </button>
              </div>
            </div>

            <!-- Botões de Ação -->
            <div class="flex items-center gap-3">
              <button
                type="button"
                class="apple-btn apple-btn-secondary"
                @click="closeModal"
              >
                Cancelar
              </button>
              <button
                type="button"
                class="apple-btn apple-btn-primary"
                :disabled="totalSelecionados === 0 || enviando"
                @click="iniciarDisparoMassa"
              >
                <vs-icon icon="send" size="16px" class="mr-1"></vs-icon>
                Disparar {{ totalSelecionados }} Mensagens
              </button>
            </div>
          </div>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
export default {
  name: "ModalDisparoEmMassaNps",
  props: {
    active: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      localActive: false,
      etapa: "selecao", // 'selecao' | 'progresso'
      carregandoElegiveis: false,
      enviando: false,
      elegiveis: [],
      totalDisponiveis: 0,
      paginaAtual: 1,
      totalPaginas: 1,
      itensPorPagina: 50,
      filtroPreset: "60", // '7' | '30' | '60' | '90' | 'all'
      filtroDataDe: "",
      filtroDataAte: "",
      filtroBusca: "",
      timerBusca: null,
      todosSelecionadosTotal: false,
      progress: {
        status: "idle",
        message: "Iniciando disparo...",
        percent: 0,
        total: 0,
        sent: 0,
        failed: 0
      }
    };
  },
  computed: {
    totalSelecionados() {
      return (this.elegiveis || []).filter(item => item.selecionado && item.temTelefoneValido).length;
    },
    totalComTelefoneNaPagina() {
      return (this.elegiveis || []).filter(item => item.temTelefoneValido).length;
    },
    todosSelecionadosNaPagina() {
      const comTel = (this.elegiveis || []).filter(item => item.temTelefoneValido);
      return comTel.length > 0 && comTel.every(item => item.selecionado);
    },
    corStatus() {
      if (this.progress.status === "completed") return "#34c759";
      if (this.progress.status === "error") return "#ff3b30";
      return "#0071e3";
    }
  },
  watch: {
    active(val) {
      this.localActive = val;
      if (val) {
        this.etapa = "selecao";
        this.paginaAtual = 1;
        this.filtroPreset = "60";
        this.filtroBusca = "";
        this.filtroDataDe = "";
        this.filtroDataAte = "";
        this.carregarElegiveis();
      }
    },
    localActive(val) {
      this.$emit("update:active", val);
    }
  },
  methods: {
    closeModal() {
      this.localActive = false;
    },
    formatarData(dt) {
      if (!dt) return "";
      const s = String(dt).split("T")[0];
      const p = s.split("-");
      if (p.length === 3) {
        return `${p[2]}/${p[1]}/${p[0]}`;
      }
      return dt;
    },
    formatarTelefone(tel) {
      if (!tel) return "";
      const digits = String(tel).replace(/\D/g, "");
      if (digits.length === 11) {
        return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
      } else if (digits.length === 10) {
        return `(${digits.slice(0, 2)}) ${digits.slice(2, 6)}-${digits.slice(6)}`;
      } else if (digits.length === 13 && digits.indexOf("55") === 0) {
        return `(${digits.slice(2, 4)}) ${digits.slice(4, 9)}-${digits.slice(9)}`;
      } else if (digits.length === 12 && digits.indexOf("55") === 0) {
        return `(${digits.slice(2, 4)}) ${digits.slice(4, 8)}-${digits.slice(8)}`;
      }
      return tel;
    },
    debounceBusca() {
      if (this.timerBusca) clearTimeout(this.timerBusca);
      this.timerBusca = setTimeout(() => {
        this.paginaAtual = 1;
        this.carregarElegiveis();
      }, 400);
    },
    limparBusca() {
      this.filtroBusca = "";
      this.paginaAtual = 1;
      this.carregarElegiveis();
    },
    aplicarPresetDias(preset) {
      this.filtroPreset = preset;
      this.filtroDataDe = "";
      this.filtroDataAte = "";
      this.paginaAtual = 1;
      this.carregarElegiveis();
    },
    onDateChange() {
      if (this.filtroDataDe || this.filtroDataAte) {
        this.filtroPreset = "";
      }
      this.paginaAtual = 1;
      this.carregarElegiveis();
    },
    mudarPagina(novaPagina) {
      if (novaPagina < 1 || novaPagina > this.totalPaginas) return;
      this.paginaAtual = novaPagina;
      this.carregarElegiveis();
    },
    mudarItensPorPagina() {
      this.paginaAtual = 1;
      this.carregarElegiveis();
    },
    async carregarElegiveis() {
      this.carregandoElegiveis = true;
      try {
        const params = {
          page: this.paginaAtual,
          limit: this.itensPorPagina
        };

        if (this.filtroBusca) {
          params.busca = this.filtroBusca;
        }

        if (this.filtroDataDe && this.filtroDataAte) {
          params.dataDe = this.filtroDataDe;
          params.dataAte = this.filtroDataAte;
        } else if (this.filtroPreset && this.filtroPreset !== "all") {
          params.dias = this.filtroPreset;
        }

        const res = await this.$http.get("nps/elegiveis", { params });
        if (res && res.success && Array.isArray(res.elegiveis)) {
          this.elegiveis = res.elegiveis;
          this.totalDisponiveis = res.total || res.elegiveis.length;
          this.totalPaginas = res.lastPage || 1;
          this.paginaAtual = res.page || 1;
        } else {
          this.elegiveis = [];
          this.totalDisponiveis = 0;
          this.totalPaginas = 1;
        }
      } catch (err) {
        console.error(err);
        this.elegiveis = [];
        this.totalDisponiveis = 0;
      } finally {
        this.carregandoElegiveis = false;
      }
    },
    toggleSelecionarPagina() {
      const novoEstado = !this.todosSelecionadosNaPagina;
      this.elegiveis.forEach(item => {
        if (item.temTelefoneValido) {
          item.selecionado = novoEstado;
        }
      });
    },
    toggleSelecionarTodosTotal() {
      this.todosSelecionadosTotal = !this.todosSelecionadosTotal;
      this.elegiveis.forEach(item => {
        if (item.temTelefoneValido) {
          item.selecionado = this.todosSelecionadosTotal;
        }
      });
    },
    async iniciarDisparoMassa() {
      const selecionados = (this.elegiveis || []).filter(item => item.selecionado && item.temTelefoneValido);
      if (selecionados.length === 0) return;

      this.etapa = "progresso";
      this.enviando = true;
      this.progress = {
        status: "sending",
        message: "Enviando pesquisas NPS pelo WhatsApp...",
        percent: 0,
        total: selecionados.length,
        sent: 0,
        failed: 0
      };

      try {
        const res = await this.$http.post("nps/disparar-massa", { itens: selecionados });
        if (res && res.success) {
          this.progress.sent = res.enviados || 0;
          this.progress.failed = res.falhas || 0;
          this.progress.percent = 100;
          this.progress.status = "completed";
          this.progress.message = `Disparo finalizado com sucesso! ${res.enviados} mensagens enviadas.`;
        } else {
          this.progress.status = "error";
          this.progress.message = (res && res.message) || "Erro ao realizar disparos.";
        }
      } catch (err) {
        this.progress.status = "error";
        this.progress.message = (err && err.response && err.response.data && err.response.data.message) || "Erro na requisição de disparo.";
      } finally {
        this.enviando = false;
      }
    },
    finalizarEnvio() {
      this.closeModal();
      this.$emit("concluido");
    }
  }
};
</script>

<style scoped>
/* Apple Modal Overrides */
::v-deep .vs-popup {
  width: 94vw !important;
  max-width: 1080px !important;
  border-radius: 20px !important;
  border: 1px solid rgba(0, 0, 0, 0.08) !important;
  box-shadow: 0 30px 60px -12px rgba(0, 0, 0, 0.25), 0 18px 36px -18px rgba(0, 0, 0, 0.15) !important;
  overflow: hidden !important;
  font-family: -apple-system, BlinkMacSystemFont, "SF Pro Display", "SF Pro Text", "Inter", sans-serif !important;
}

::v-deep .vs-popup--header {
  display: none !important;
}

::v-deep .vs-popup--content {
  padding: 0 !important;
  margin: 0 !important;
}

.apple-modal-wrapper {
  position: relative;
  padding: 26px 30px;
  background: #ffffff;
}

.apple-close-btn {
  position: absolute;
  top: 18px;
  right: 18px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #f1f5f9;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #64748b;
  cursor: pointer;
  transition: all 0.2s ease;
  z-index: 10;
}
.apple-close-btn:hover {
  background: #e2e8f0;
  color: #0f172a;
}

/* Header */
.apple-header-icon-box {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: #f0f7ff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.apple-modal-title {
  font-size: 1.35rem;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
  letter-spacing: -0.3px;
}

.apple-modal-subtitle {
  font-size: 0.85rem;
  color: #64748b;
  margin: 2px 0 0 0;
}

/* Filter Toolbar */
.apple-filter-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 10px 14px;
}

.apple-segmented-group {
  display: inline-flex;
  background: #e2e8f0;
  padding: 2px;
  border-radius: 8px;
}

.apple-seg-btn {
  border: none;
  background: transparent;
  padding: 4px 10px;
  font-size: 11px;
  font-weight: 600;
  color: #475569;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.15s ease;
}
.apple-seg-btn:hover {
  color: #0f172a;
}
.apple-seg-btn.active {
  background: #ffffff;
  color: #0071e3;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.apple-date-input {
  border: 1px solid #cbd5e1;
  background: #ffffff;
  border-radius: 6px;
  padding: 3px 8px;
  font-size: 11px;
  color: #334155;
  outline: none;
}
.apple-date-input:focus {
  border-color: #0071e3;
}

/* Controls Bar */
.apple-controls-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
}

.apple-pill-btn {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  padding: 5px 12px;
  border-radius: 9999px;
  font-size: 11px;
  font-weight: 600;
  color: #334155;
  cursor: pointer;
  transition: all 0.2s ease;
}
.apple-pill-btn:hover {
  background: #f1f5f9;
  border-color: #cbd5e1;
}
.apple-pill-btn.active {
  background: #0f172a;
  color: #ffffff;
  border-color: #0f172a;
}

.apple-search-box {
  position: relative;
  display: flex;
  align-items: center;
  background: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  padding: 4px 10px;
  min-width: 230px;
  transition: all 0.2s ease;
}
.apple-search-box:focus-within {
  border-color: #0071e3;
  box-shadow: 0 0 0 3px rgba(0, 113, 227, 0.12);
}

.apple-search-input {
  border: none;
  background: transparent;
  outline: none;
  font-size: 11px;
  color: #0f172a;
  margin-left: 6px;
  width: 100%;
}

.apple-clear-search {
  cursor: pointer;
  color: #94a3b8;
  font-size: 14px;
  padding: 0 4px;
}

.apple-mini-select {
  border: 1px solid #cbd5e1;
  background: #ffffff;
  border-radius: 6px;
  padding: 3px 6px;
  font-size: 11px;
  color: #334155;
  outline: none;
}

/* Table */
.apple-table-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.02);
}

.apple-table-scroll {
  max-height: 420px;
  overflow-y: auto;
}

.apple-table {
  width: 100%;
  border-collapse: collapse;
  text-align: left;
  font-size: 13px;
}

.apple-table thead th {
  background: #f8fafc;
  padding: 10px 14px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  color: #64748b;
  border-bottom: 1px solid #e2e8f0;
  position: sticky;
  top: 0;
  z-index: 2;
}

.apple-tr {
  border-bottom: 1px solid #f1f5f9;
  transition: background 0.15s ease;
}
.apple-tr:hover {
  background: #f8fafc;
}
.apple-tr.is-selected {
  background: #f0fdf4;
}
.apple-tr.is-disabled {
  opacity: 0.6;
}

.apple-table tbody td {
  padding: 10px 14px;
  vertical-align: middle;
}

.apple-client-name {
  font-weight: 600;
  color: #0f172a;
  font-size: 13px;
}

.apple-client-meta {
  font-size: 11px;
  color: #94a3b8;
  margin-top: 2px;
  display: flex;
  align-items: center;
  gap: 4px;
}

.apple-dot {
  color: #cbd5e1;
}

.apple-badge-service {
  display: inline-block;
  background: #e0f2fe;
  color: #0369a1;
  font-size: 11px;
  font-weight: 700;
  padding: 2px 8px;
  border-radius: 9999px;
}

.apple-service-meta {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 2px;
}

.apple-pill-subtle {
  font-size: 10px;
  color: #475569;
  background: #f1f5f9;
  padding: 1px 6px;
  border-radius: 4px;
  font-weight: 600;
}

.apple-pill-stage {
  font-size: 10px;
  color: #0d9488;
  background: #f0fdfa;
  padding: 1px 6px;
  border-radius: 4px;
  font-weight: 600;
}

/* Select & Inputs */
.apple-select-wrapper {
  position: relative;
  width: 100%;
}

.apple-select {
  width: 100%;
  appearance: none;
  background: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  padding: 7px 30px 7px 10px;
  font-size: 12px;
  font-weight: 500;
  color: #0f172a;
  outline: none;
  cursor: pointer;
  transition: all 0.2s ease;
}
.apple-select:hover {
  border-color: #94a3b8;
}
.apple-select:focus {
  border-color: #0071e3;
  box-shadow: 0 0 0 3px rgba(0, 113, 227, 0.15);
}

.apple-select-arrow {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  color: #64748b;
  display: flex;
  align-items: center;
}

.apple-input-tel {
  width: 100%;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  padding: 7px 10px;
  font-size: 12px;
  outline: none;
}
.apple-input-tel:focus {
  border-color: #0071e3;
  box-shadow: 0 0 0 3px rgba(0, 113, 227, 0.15);
}

.apple-tag-danger {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: #e11d48;
  background: #ffe4e6;
  font-size: 11px;
  font-weight: 600;
  padding: 4px 8px;
  border-radius: 6px;
}

.apple-checkbox {
  width: 16px;
  height: 16px;
  accent-color: #0071e3;
  cursor: pointer;
}

/* Footer & Buttons */
.apple-modal-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 6px;
}

.apple-footer-summary {
  font-size: 12px;
  color: #64748b;
}

.apple-pagination-controls {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 2px 6px;
}

.apple-page-btn {
  border: none;
  background: transparent;
  color: #475569;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2px 4px;
  border-radius: 4px;
  transition: all 0.15s ease;
}
.apple-page-btn:hover:not(:disabled) {
  background: #e2e8f0;
  color: #0f172a;
}
.apple-page-btn:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

.apple-page-indicator {
  font-size: 11px;
  font-weight: 600;
  color: #334155;
  padding: 0 4px;
}

.apple-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 600;
  border-radius: 10px;
  padding: 9px 20px;
  border: none;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);
}

.apple-btn-secondary {
  background: #f1f5f9;
  color: #475569;
}
.apple-btn-secondary:hover {
  background: #e2e8f0;
  color: #0f172a;
}

.apple-btn-primary {
  background: #10b981;
  color: #ffffff;
  box-shadow: 0 2px 6px rgba(16, 185, 129, 0.25);
}
.apple-btn-primary:hover {
  background: #059669;
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.35);
  transform: translateY(-1px);
}
.apple-btn-primary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
}

/* Progress States */
.apple-progress-bar-bg {
  width: 100%;
  height: 8px;
  background: #f1f5f9;
  border-radius: 9999px;
  overflow: hidden;
}

.apple-progress-bar-fill {
  height: 100%;
  transition: width 0.4s ease;
}

.apple-metrics-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
}

.apple-metric-card {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  padding: 16px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.apple-metric-num {
  font-size: 1.75rem;
  font-weight: 800;
  line-height: 1.2;
}

.apple-metric-label {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  color: #64748b;
  margin-top: 4px;
}

.apple-spinner-ring {
  width: 48px;
  height: 48px;
  margin: 0 auto;
  border: 4px solid #f1f5f9;
  border-top-color: #0071e3;
  border-radius: 50%;
  animation: appleSpin 0.8s linear infinite;
}

@keyframes appleSpin {
  to { transform: rotate(360deg); }
}
</style>
